import PetitionCreationSuccess from './PetitionCreationSuccess';

export default PetitionCreationSuccess;
